<template>
  <div>
    <v-card
      flat
    >
      <v-toolbar dense dark color="primary">
        <v-toolbar-title><h4 class="font-weight-light">SEARCH OR NO IN REMITTANCES</h4>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-combobox
          class="mt-6"
          :append-icon="icons.mdiAccountSearchOutline"
          v-model="search"
          @keyup="searching($event.target.value)"
          placeholder="Search by OR #"
          ref="memberCombobox"
          dense
          outlined
        ></v-combobox>
      </v-card-text>
      <v-data-table dense
                    :headers="headers"
                    :items="search_items"
      >
        <template v-slot:item="{ item }">
          <tr
            @click="activerow(item)"
            :class="{'info black--text': item.id===selectedDepositId}"
          >
            <td class="text-center">
              {{ item.branch.branch_code }}
            </td>
            <td class="text-center">{{ item.or_date }}</td>
            <td class="text-center">
              {{ item.or_no }}
            </td>
            <td class="text-center">
              {{ item.member_name }}
            </td>
            <td class="text-center">
              {{ item.amount }}
            </td>
            <td class="text-center">
              {{ item.remarks}}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog_show" width="80%">
      <v-card
        flat
      >
        <v-toolbar dense dark color="primary">
          <v-toolbar-title><h4 class="font-weight-light">DEPOSIT DATA</h4>
          </v-toolbar-title>
        </v-toolbar>
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-center text-uppercase">
                Deposit ID
              </th>
              <th class="text-center text-uppercase">
                Bank
              </th>
              <th class="text-center text-uppercase">
                Date
              </th>
              <th class="text-center text-uppercase">
                Time
              </th>
              <th class="text-center text-uppercase">
                Amount
              </th>
              <th class="text-center text-uppercase">
                Month
              </th>
              <th class="text-center text-uppercase">
                Collector
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="item in passbook_data"
              :key="item.id"
            >
              <td class="text-center">{{ item.id }}</td>
              <td class="text-center">
                {{ item.bank_code_name }}
              </td>
              <td class="text-center">
                {{ item.date_of_deposit }}
              </td>
              <td class="text-center">
                {{ item.time_of_deposit }}
              </td>
              <td class="text-center">
                {{ item.amount }}
              </td>
              <td class="text-center">
                {{ item.month_of }}
              </td>
              <td class="text-center">
                {{ item.collector }}
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {mdiEyeOutline} from '@mdi/js'
  import {mapGetters, mapActions} from "vuex";
  import snackBarDialog from '@/components/dialogs/notifications_dialog/Snackbar'

  export default {
    components: {
      snackBarDialog,
    },
    setup() {
      return {
        icons: {
          mdiEyeOutline,
        },
      }
    },
    data() {
      return {
        dialog_show: false,

        saving: false,
        alert: false,
        alert_message: '',

        search: '',
        search_member: '',
        search_items: [],
        balance: 0,
        balance_num: 0,

        account_id: '',
        account_no: '',
        account_name: '',
        amount: 0,

        status: '',

        passbook_data: [],
        data: [],

        headers: [
          {text: 'BRANCH', value: 'id', sortable: false},
          {text: 'OR DATE', value: 'id', sortable: false},
          {text: 'OR NO', value: 'date_of_deposit', sortable: false},
          {text: 'NAME', value: 'time_of_deposit', sortable: false},
          {text: 'AMOUNT', value: 'amount', sortable: false},
          {text: 'REMARKS', value: 'bank_code_name', sortable: false},],
        selectedDepositId: -1,
      }
    },
    watch: {
      search_member: function () {
        if (this.timeout) clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          if (this.search_member == '') {
            this.search_items = []
          } else {
            this.searching_search_items(this.search_member)
          }
        }, 500)
      },
    },
    computed: {
      ...mapGetters('form_rules', ['rules']),
      ...mapGetters('authentication', ['branch_id']),
      ...mapGetters('system_data', ['snackbar', 'snackbar_color', 'snackbar_text']),
    },
    methods: {
      ...mapActions('system_data', ['change_snackbar']),
      ...mapActions('deposit_slip', ['search_remittances_data']),
      searching(value) {
        this.search_member = value
      },
      searching_search_items(value) {
        this.search_remittances_data({
          or_no: value
        })
          .then(response => {
            this.search_items = response.data
          })
      },
      activerow(value) {
        this.data = value
        this.dialog_show = true
        this.selectedDepositId = value.id;
        this.passbook_data = value.deposit_slip
      },
    }
  }
</script>
